/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { adminv3_AlertListRequest } from "../models/adminv3_AlertListRequest"
import type { adminv3_AlertResponse } from "../models/adminv3_AlertResponse"
import type { adminv3_CreateAlertRequest } from "../models/adminv3_CreateAlertRequest"
import type { adminv3_PublishRequest } from "../models/adminv3_PublishRequest"
import type { adminv3_UpdateAlertRequest } from "../models/adminv3_UpdateAlertRequest"
import type { avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AlertListItem } from "../models/avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AlertListItem"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class AlertsService {
    /**
     * Create a new alert
     * Create a new alert with the specified details
     * @returns adminv3_AlertResponse Created
     * @throws ApiError
     */
    public static postV3AdminAlert({
        request,
    }: {
        /** Create Alert Request **/
        request: adminv3_CreateAlertRequest
    }): CancelablePromise<adminv3_AlertResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/alert",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * List all alerts
     * Retrieve a list of all alerts
     * @returns avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AlertListItem OK
     * @throws ApiError
     */
    public static postV3AdminAlertList({
        request,
    }: {
        /** Alert List Request **/
        request: adminv3_AlertListRequest
    }): CancelablePromise<avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AlertListItem> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/alert/list",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Get an alert by ID
     * Retrieve an alert by its ID
     * @returns adminv3_AlertResponse OK
     * @throws ApiError
     */
    public static getV3AdminAlert({
        id,
    }: {
        /** Alert ID **/
        id: number
    }): CancelablePromise<adminv3_AlertResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v3/admin/alert/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Update an alert by ID
     * Update an existing alert with the specified details
     * @returns any OK
     * @throws ApiError
     */
    public static putV3AdminAlert({
        id,
        request,
    }: {
        /** Alert ID **/
        id: number
        /** Update Alert Request **/
        request: adminv3_UpdateAlertRequest
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/v3/admin/alert/{id}",
            path: {
                id: id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Delete an alert by ID
     * Delete an alert by its ID
     * @returns any OK
     * @throws ApiError
     */
    public static deleteV3AdminAlert({
        id,
    }: {
        /** Alert ID **/
        id: number
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/v3/admin/alert/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Publish an alert
     * Publish an alert to specified segments
     * @returns void
     * @throws ApiError
     */
    public static putV3AdminAlertPublish({
        id,
        request,
    }: {
        /** Alert ID **/
        id: number
        /** Publish alert request **/
        request: adminv3_PublishRequest
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/v3/admin/alert/{id}/publish",
            path: {
                id: id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }
}
